export default {
    title: `Mes autres réseaux`,
    subTitle: `Les statistiques sur ce(s) réseau(x) ne sont pas encore disponibles.`,
    edit: `Ajouter ou modifier mes réseaux`,
    add: `Ajouter mes autres réseaux`,
};
